// node_modules
import { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
// Components
import { FindestEditableLabelledCheckbox } from "Components";
// Style
import styles from "./synonym.module.scss";
// Types
import { TSynonymDTO } from "Types";

type TSynonymProps = {
    synonym: TSynonymDTO,
    handleIsSynonymRequiredOnChange?: (isSynonymRequired: boolean, synonymUpdated: TSynonymDTO) => void,
    handleDeleteSynonym?: (synonymToDelete: TSynonymDTO) => void,
    handleEditSynonym?: (id: number, newValue: string, oldValue: string) => void,
    handleOnFocusSynonym?: (event: React.FocusEvent) => void,
    setSynonymPopupText?: (text: string) => void
}

export const Synonym: FC<TSynonymProps> = ({synonym, handleIsSynonymRequiredOnChange, handleDeleteSynonym, handleEditSynonym, 
        handleOnFocusSynonym, setSynonymPopupText}: TSynonymProps) => {
    // Logic
    const handleOnCheckboxChange = (): void => {
        if(!handleIsSynonymRequiredOnChange) return;
        handleIsSynonymRequiredOnChange(!synonym.required, synonym);
    };

    const handleOnLabelChange = (newValue: string, oldValue: string): void => {
        if(!handleEditSynonym) return;
        handleEditSynonym(synonym.id, newValue, oldValue);

        if(setSynonymPopupText) setSynonymPopupText(newValue);
    };

    const onFocusText = (event: React.FocusEvent): void => {
        if(setSynonymPopupText) setSynonymPopupText(synonym.text);
        if(handleOnFocusSynonym) handleOnFocusSynonym(event);
    };

    const deleteSynonym = (): void => {
        if(!handleDeleteSynonym) return;
        handleDeleteSynonym(synonym);
    };

    return (
        <div className={styles.findestSynonym}>
            <FindestEditableLabelledCheckbox label={synonym.text} placeholder={"Synonym"} checked={synonym.required}
                onCheckboxChange={handleOnCheckboxChange} onLabelChange={handleOnLabelChange} 
                onTextFocus={onFocusText} isReadonly={!handleEditSynonym} />
            {synonym.required && handleDeleteSynonym ? 
                <div title="Delete synonym">
                    <FontAwesomeIcon className={styles.deleteButton} icon={faTrashAlt} onClick={deleteSynonym} />
                </div> 
                : <></>
            }
        </div> 
    );
};